import { Box, Button, ButtonGroup, Flex, FormControl, FormLabel, Text } from "@chakra-ui/react";
import { IconButton } from "components";
import { useEffect, useRef, useState } from "react";

export default function File({ label, accept = ".pdf, image/jpeg, image/png", onChange = () => {}, isDisabled, ...props }){

    const inputRef = useRef()
    const [ file, setFile ] = useState()

    const onChangeFile = ({ target }) => {
        const file = target.files[0]
        if(!file) return
        setFile(file)
    }

    useEffect(() => {
        onChange(file)
    }, [file])

    return(
    <FormControl>
        <input ref={inputRef} type="file" style={{ display: 'none' }} accept={accept} onChange={onChangeFile} disabled={isDisabled} />
        { label && <FormLabel fontSize="sm" children={label} /> }
        <Flex w="100%" justifyContent="space-between" alignItems="center" borderWidth={1} py={2} px={3} borderRadius={4}>
            <Box>
                <Text fontSize="xs" children={file?.name ?? 'Nenhum arquivo selecionado'} />
            </Box>
            <Box>
                <ButtonGroup size="xs" isDisabled={isDisabled}>
                    <Button children="Selecionar arquivo" onClick={() => inputRef.current.click()} />
                    { file && <IconButton label="Remover arquivo" icon="trash" onClick={() => setFile(null)} /> }
                </ButtonGroup>
            </Box>
        </Flex>
    </FormControl>
    )
}